import { ACCOUNT_PAGE_NAME } from '@api/accounts/auth/consts'
import { getShopLocale } from '@helpers/env'

export function generateNonce(length: number) {
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  let nonce = ''

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length)
    nonce += characters.charAt(randomIndex)
  }

  return nonce
}

export function generateState() {
  const timestamp = Date.now().toString()
  const randomString = Math.random().toString(36).substring(2)
  return timestamp + randomString
}

export function getRedirectUrl() {
  const locale = getShopLocale()
  const localeDivider = locale === 'gb' ? '/' : `/${locale}/`
  return `${window.location.origin}${localeDivider}${ACCOUNT_PAGE_NAME}`
}

export function getHomeUrl() {
  const locale = getShopLocale()
  return locale === 'gb'
    ? `${window.location.origin}`
    : `${window.location.origin}/${locale}`
}
